<template>

    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">设备管理</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">模版名称</div>
                    <div class="header-item">配件名称</div>
                    <div class="header-item">配件类型</div>
                    <div class="header-item">备注</div>

                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in paginatedList" :key="index">
                            <div class="body-item">{{ item.deviceModel }}</div>
                            <div class="body-item">{{ item.accessoriesName }}</div>
                            <div class="body-item">{{ item.accessoriesType }}</div>
                            <div class="body-item">{{ item.remark }}</div>
                        </div>
                        <div class="empty-tip" v-if="paginatedList.length === 0">
                            暂无设备数据
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import { getModelLinkAccessories } from "@/api/accessories";

export default {
    data() {
        return {
            // 表格数据和分页
            list: [], // 原始完整数据
            loading: false,
            currentPage: 1,
            pageSize: 10,
            // 【核心修改】totalCount 已从 data 中移除，改为计算属性

            // 搜索关键词
            searchKeyword: '',

            // 搜索表单
            searchForm: {
                houseId: '',
                code: '',
            },

            // 对话框和表单
            dialogVisible: false,
            dialogTitle: '新增配件',
            formRef: null,
            form: {
                id: '',
                accessoriesName: '',
                accessoriesType: '',
                remark: '',
                unit: '',
                userid: localStorage.getItem('userId')
            },

            // 表单校验规则
            rules: {
                accessoriesName: [{ required: true, message: '请输入配件名称', trigger: 'blur' }],
                accessoriesType: [{ required: true, message: '请输入配件类型', trigger: 'blur' }],
            },
        };
    },
    computed: {
        // 【核心修改】1. 新增一个计算属性，专门用于过滤
        filteredList() {
            if (!this.searchKeyword) {
                return this.list;
            }
            const keyword = this.searchKeyword.toLowerCase();
            return this.list.filter(item =>
                item.accessoriesName.toLowerCase().includes(keyword) ||
                item.accessoriesType.toLowerCase().includes(keyword)
            );
        },
        // 【核心修改】2. 新增一个计算属性，用于获取过滤后的总数
        filteredTotalCount() {
            return this.filteredList.length;
        },
        // 【核心修改】3. 修改 paginatedList，使其依赖 filteredList
        paginatedList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            // 直接对过滤后的列表进行分页
            return this.filteredList.slice(start, end);
        }
    },
    created() {
        this.getList();
    },
    methods: {
        // 获取列表数据
        getList() {
            this.loading = true;
            getModelLinkAccessories({
                userid: localStorage.getItem('userId')
            }).then(response => {
                this.list = response.data;
            }).finally(() => {
                this.loading = false;
            });
        },

        // 处理搜索 (主要用于回车事件，重置页码)
        handleSearch() {
            this.currentPage = 1; // 每次搜索都从第一页开始
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1; // 切换每页数量时，页码重置为1
        },

        handleCurrentChange(val) {
            this.currentPage = val;
        },

        handleRowClick(row) {
            console.log('Row clicked:', row);
        },

        resetForm() {
            this.form = {
                id: '',
                accessoriesName: '',
                accessoriesType: '',
                remark: '',
                unit: ''
            };
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
        },

        showAddDialog() {
            this.dialogTitle = '新增配件';
            this.resetForm();
            this.dialogVisible = true;
        },




    }
};
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>